// react components

//ReactEcharts
import ReactEcharts from "echarts-for-react";

// react-router-dom components

// mui components

// mui-icons components

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

//routes

//redux
import { useSelector } from "react-redux";

//utils
import { getChartDataFromStatsData } from "../../../utils/AppendStatsToCharts";

function DoughnutCharts({ data = [], tTest = {}, productColors = {} }) {
    const { tTestResult } = tTest;
    const isPercentage = useSelector((state) => state.analysisResultsStore.percentageToggle);

    const { seriesData, _colors } = getChartDataFromStatsData(data, isPercentage, tTestResult, productColors);
    const allZero = seriesData.every((item) => item.value === 0);
    const displayData = allZero ? seriesData.map((item) => ({ ...item, value: 1 })) : seriesData;

    const option = {
        tooltip: {
            trigger: "item",
            confine: true,
            formatter: function (params) {
                const marker = (color) => `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:9px;height:9px;background:${color}"></span>`;
                const scoreVal = (val) => (isPercentage ? `${val}%` : val);
                const nameArr = params.data.details?.[0].name.split("/");
                const filteredTestResult = tTestResult?.[0]?.colors?.find((ele) => ele.productCode.toLowerCase() == nameArr[0].trim().toLowerCase()) || {};
                const testLabel = filteredTestResult?.label || "";
                let tooltipText = ``;
                if (params.data.details) {
                    tooltipText += params.data.details.map((detail) => `${marker(productColors[nameArr[0].trim().split(" ").join("_")])} <span style="font-weight: bold;">${detail.name}</span> : <span>${scoreVal(detail.value)}</span> <span style="font-weight: bold; margin-left: 4px;">${testLabel}</span>`).join("");
                }
                tooltipText += `</div>`;
                return tooltipText;
            },
            textStyle: {
                fontSize: 12,
            },
        },
        legend: {
            top: "5%",
            bottom: "5%",
            left: "center",
            type: "scroll",
            selectedMode: false,
        },
        color: _colors,
        series: [
            {
                type: "pie",
                radius: ["25%", "50%"],
                // center: ["50%", "70%"],
                // startAngle: 180,
                // endAngle: 360,
                data: displayData,
                label: {
                    show: true,
                    position: "outside",
                    formatter: function (params) {
                        return isPercentage ? `${params.value}%` : `${params.value}`;
                    },
                    fontSize: displayData.length > 10 ? 9 : 11,
                    fontWeight: "normal",
                    alignTo: "labelLine",
                    lineHeight: displayData.length > 10 ? 11 : 15,
                    // width: displayData.length > 10 ? 70 : 100,
                    overflow: "truncate",
                    ellipsis: "...",
                },
                labelLine: {
                    show: true,
                    length: displayData.length > 10 ? 45 : 10,
                    length2: displayData.length > 10 ? 40 : 10,
                    smooth: true,
                },
            },
        ],
    };

    return (
        <div style={{ overflow: "auto" }}>
            <ReactEcharts
                option={option}
                style={{ minWidth: "450px", maxHeight: "450px" }}
                opts={{ renderer: "svg" }}
            />
        </div>
    );
}

// Typechecking props for the HalfDoughnutCharts
DoughnutCharts.propTypes = {
    // title: PropTypes.string,
    data: PropTypes.array,
    tTest: PropTypes.object,
    productColors: PropTypes.object,
};

export default DoughnutCharts;
